// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"table_wrapper__x4mzM","hoverable":"table_hoverable__2KUek","header":"table_header__wUmfq"};